// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1480px) {
  .distributionDetails {
    flex-wrap: wrap;
  }
}

@media (min-width: 1480px) {
  .distributionDetailsContainer {
    border-top-right-radius: 15px;
  }
}

@media (max-width: 1480px) {
  .detailsViewContainer {
    width: 100% !important;
    justify-content: center;
    border-top-right-radius: 15px;
    border-bottom-left-radius: 0px !important;
    border-right: 1px solid #dce0e8 !important;
    border-bottom: none !important;
  }
}

#insightsTable {
  width: 100%;
  table-layout: fixed;
}

#insightsTable th {
  position: relative;
  font-size: 14px;
  font-weight: normal;
}

#insightsTable th,
#insightsTable td {
  text-align: left;
  padding: 16px 20px;
  min-width: 50px;
}
#insightsTable th:last-child {
  padding: 8px 2px !important;
}
#insightsTable th:nth-child(3) {
  padding-left: 0px !important;
}
span {
  justify-content: center;
  align-items: center;
}

#insightsTable td span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}

#insightsTable {
  border-collapse: separate;
  border-spacing: 0px;
}

/* top-left border-radius */
#insightsTable tr:first-child th:first-child {
  border-top-left-radius: 8px;
}

/* top-right border-radius */
#insightsTable tr:first-child th:last-child {
  border-top-right-radius: 8px;
}

.distname {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 3.6em;
  line-height: 1.7em;
}

@media (max-width: 1800px) {
  .InsightsTableView {
    height: 690px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./app/styles/insights.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,yCAAyC;IACzC,0CAA0C;IAC1C,8BAA8B;EAChC;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@media (max-width: 1480px) {\n  .distributionDetails {\n    flex-wrap: wrap;\n  }\n}\n\n@media (min-width: 1480px) {\n  .distributionDetailsContainer {\n    border-top-right-radius: 15px;\n  }\n}\n\n@media (max-width: 1480px) {\n  .detailsViewContainer {\n    width: 100% !important;\n    justify-content: center;\n    border-top-right-radius: 15px;\n    border-bottom-left-radius: 0px !important;\n    border-right: 1px solid #dce0e8 !important;\n    border-bottom: none !important;\n  }\n}\n\n#insightsTable {\n  width: 100%;\n  table-layout: fixed;\n}\n\n#insightsTable th {\n  position: relative;\n  font-size: 14px;\n  font-weight: normal;\n}\n\n#insightsTable th,\n#insightsTable td {\n  text-align: left;\n  padding: 16px 20px;\n  min-width: 50px;\n}\n#insightsTable th:last-child {\n  padding: 8px 2px !important;\n}\n#insightsTable th:nth-child(3) {\n  padding-left: 0px !important;\n}\nspan {\n  justify-content: center;\n  align-items: center;\n}\n\n#insightsTable td span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: block;\n}\n\n#insightsTable {\n  border-collapse: separate;\n  border-spacing: 0px;\n}\n\n/* top-left border-radius */\n#insightsTable tr:first-child th:first-child {\n  border-top-left-radius: 8px;\n}\n\n/* top-right border-radius */\n#insightsTable tr:first-child th:last-child {\n  border-top-right-radius: 8px;\n}\n\n.distname {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-height: 3.6em;\n  line-height: 1.7em;\n}\n\n@media (max-width: 1800px) {\n  .InsightsTableView {\n    height: 690px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
